const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domHeader: $('.js-site-header'),
	$domHeaderNotice: $('.js-site-header__notice'),
	$domHeaderNoticeIcon: $('.js-site-header__notice-desc-ico'),
	$domMenuItemSecondChild: $('.menu-item-special-mm'),
	$domMegaMenu: $('.js-site-header__megamenu'),
	classActive: 'is-active',
	classHasNotice: 'has-notice',
	classIsCurrentMenu: 'is-current-menu',
	classHeaderScroll: 'is-sticky',
	classHasPadding: 'has-padding',

	/** @description Initialize */
	init: function() {
		if($('.site-header__megamenu-box').length > 8) {
			Header.$domMegaMenu.addClass('megamenu-box-active');
		}

		if($('.switch-block__upper-box').length > 8) {
			$('.switch-block__upper-wrap').addClass('switch-box-active');
		}

		this.headerScroll();
		this.headerNoticeClose();
		if(window.innerWidth > 1198) {
			this.megaMenu();
		}
		this.headerBodyNotice();
		this.headerStickyOnLoad();
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	headerNoticeClose: function() {
		Header.$domHeaderNoticeIcon.on('click', function() {
			Header.$domHeaderNotice.removeClass(Header.classActive);
			Header.$domHeader.removeClass(Header.classHasNotice);
			Header.$domBody.removeClass(Header.classHasPadding);
		});
	},

	megaMenu: function() {
		Header.$domMegaMenu.appendTo(Header.$domMenuItemSecondChild);
		Header.$domMenuItemSecondChild.on('mouseover', function() {
			Header.$domMegaMenu.addClass(Header.classActive);
			if(Header.$domMegaMenu.hasClass(Header.classActive)) {
				Header.$domMenuItemSecondChild.addClass(Header.classIsCurrentMenu);
			} else {
				Header.$domMenuItemSecondChild.removeClass(Header.classIsCurrentMenu);
			}
		});
		Header.$domMenuItemSecondChild.on('mouseleave', function() {
			Header.$domMegaMenu.removeClass(Header.classActive);
		});
	},

	headerBodyNotice: function() {
		if(Header.$domHeader.hasClass(Header.classHasNotice)) {
			Header.$domBody.addClass(Header.classHasPadding);
		} else {
			Header.$domBody.removeClass(Header.classHasPadding);
		}
	},

	headerStickyOnLoad: function() {
		$(window).on('load', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	}
};

export default Header;
